import { Box, Card, CardContent, Grid, Typography,Button } from "@mui/material"
import { useTranslation } from 'react-i18next';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import { visuallyHidden } from '@mui/utils';


function KeyResourceCards() {
    const { t, i18n } = useTranslation();
    const data: any = t('basepage.support.KeyResources', { returnObjects: true });
    const navigate = useNavigate();
    const handleNavigate = (name) => {
        if(name==='FAQ'){
            setTimeout(()=>{window.scrollTo({ top: 0, behavior: 'smooth' });},60);
            navigate(`/${i18n.language}/support/faq`);
        
        }
        if(name==='Capabilities' || name==='Capacités' ){
            setTimeout(()=>{window.scrollTo({ top: 0, behavior: 'smooth' });},60);
            navigate(`/${i18n.language}/ndc-program/ndc-capabilities`);
        
        }
        if(name==='Release Notes' || name==='Notes de mise à jour'){
            setTimeout(()=>{window.scrollTo({ top: 0, behavior: 'smooth' });},60);
            navigate(`/${i18n.language}/api/releasenotes`);
        
        }
        if(name==='API Documentation' || name==='Documentation de l’API'){
            setTimeout(()=>{window.scrollTo({ top: 0, behavior: 'smooth' });},60);
            navigate(`/${i18n.language}/api/documentation/ndcapis`);
       
        }
        
      }
    return (
        <Box component='section' aria-labelledby='section-heading' sx={{ py: '64px' }}>
            <Box
                sx={{
                    mb: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap:'12px'
                }}
            >
                <Typography id='section-heading' variant="h2" sx={{ fontWeight: '700 !important', fontSize:'28px !important', lineHeight:'32px !important'}}>
                    {data.header}
                </Typography>
                <Typography variant="body2" sx={{fontWeight:'400', fontSize:'18px', lineHeight:'22px'}}>
                    {data.body}
                </Typography>
            </Box>
            <Grid component='ul' container spacing={'32px'} sx={{paddingLeft:"0px"}}>
                {
                    data.cards.map((item, index) => (
                        <Grid component='li' sx={{listStyle:'none'}} item xs={12} sm={6} md={6} key={index}>
                            <Card
                                elevation={0}
                                sx={{
                                    height:'100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    backgroundColor:"#FFFFFF",
                                    boxShadow:'0px 0px 15px 0px rgba(0,0,0,0.15)',
                                    borderRadius:'16px',
                                    px:'24px',
                                    py:'32px',
                                }}>
                                <CardContent
                                    sx={{ p: 0, '&:last-child': { pb: 0 }, flexGrow: 1, display:'flex',flexDirection:'column', gap:'24px',alignItems:'flex-start' }}>
                                    <Box
                                        sx={{
                                            height:80,
                                            width:80,
                                            borderRadius:'50%',
                                            display:'flex',
                                            justifyContent:'center',
                                            alignItems:'center',
                                        }}
                                        >
                                            <Box
                                            component="img"
                                            src={item.img}
                                            sx={{height:'80px', width:'80px'}}>

                                            </Box>
                                        </Box>
                                        <Box component="span" sx={visuallyHidden}>{`${data.label} ${index+1} of 4`}</Box>
                                        <Box sx={{display:'flex',flexDirection:'column'}}>
                                        <Typography id={`keyCard-heading-${index}`} variant="h3" sx={{fontWeight:700,fontSize:'20px',lineHeight:'28px',mb:'16px'}}>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="body2" sx={{fontSize:'14px'}}>
                                            {item.body}
                                        </Typography>
                                        </Box>
                                        <Button role="link" component='a' id={`button-heading-${index}`} aria-labelledby={`button-heading-${index} keyCard-heading-${index}`} variant="text" onClick={()=>handleNavigate(item.title)} sx={{display:'flex',alignItems:'center',mt:'auto','&.Mui-focusVisible':{ outline: '2px solid black', outlineOffset: '2px' }}} endIcon={<ArrowForwardIosIcon/>}>
                                            {item.button}
                                        </Button>
                                    
                                </CardContent>
                            </Card>


                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )
}

export default KeyResourceCards